import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdCloudUpload } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";
import Sidebar from "../Sidebar";
import Layout from "../Layout";
import "../../index.css";
import { useQuery, gql, useMutation } from "@apollo/client";
import axios from "axios";
import Loader from "../../Loader";
import CustomSelect from "../CommonComponents/CustomSelect";
import LabledInput from "../CommonComponents/LabledInput";
import LabeledSwitch from "../CommonComponents/CustomSwitch";
import { ca } from "date-fns/locale";
import BackButton from "../CommonComponents/BackButton";

const ADD_INVENTORY = gql`
  mutation addInventory($data: addInventoryInput!) {
    addInventory(data: $data) {
      status
      message
    }
  }
`;
const GET_INVENTORY_CATEGORY = gql`
  query {
    getInventoryCategory {
      message
      status
      categories {
        id
        name
        abbr
        parts
        minStock
      }
    }
  }
`;

const AddInventory = () => {
  const navigate = useNavigate();
  const {
    loading,
    error,
    data: categoryData,
  } = useQuery(GET_INVENTORY_CATEGORY);

  const [addInventory, { addLoading, addError }] = useMutation(ADD_INVENTORY);

  const [category, setCategory] = useState("");
  const [brand, setBrand] = useState("");
  const [date, setDate] = useState("");
  const [count, setCount] = useState(1);
  const [categoryList, setCategoryList] = useState([]);

  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    try {
      setIsFetched(true);
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    console.log("categoryData is");
    console.log(categoryData);
    if (categoryData?.getInventoryCategory?.categories) {
      setCategoryList(categoryData.getInventoryCategory.categories);
      setIsFetched(true);
    }
  }, [categoryData]);

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };
  const handleBrandChange = (e) => {
    setBrand(e.target.value);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevent double clicks
    setIsSubmitting(true);
    let finalDataObj = {};
    finalDataObj.categoryId = category;
    finalDataObj.date = new Date(date).toISOString();
    finalDataObj.count = parseInt(count);
    console.log(finalDataObj);
    addInventory({
      variables: {
        data: finalDataObj,
      },
    })
      .then((res) => {
        console.log("addInventory res is");
        console.log(res);
        if (res.data.addInventory.status === "SUCCESS") {
          window.location = "/admin/inventory-table";
          // navigate("/admin/sub-category");
        } else {
          setIsSubmitting(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsSubmitting(false);
      });
  };

  // const subCategoryClass = subCategory ? "text-white" : " text-[#9A9A9A]";
  const categoryClass = category ? "text-white" : " text-[#9A9A9A]";
  if (addLoading) return <Loader />; // Show Loader while loading;
  console.log(categoryList);
  return (
    <>
      <div className="min-h-screen flex">
        <Sidebar />
        <Layout>
          {isFetched && (
            <div className="flex flex-col py-3 px-2 space-y-5">
              <BackButton onClick={() => navigate(-1)} />
              <h3 className="text-[#FBB033] font-be-jost-pro font-bold text-2xl">
                Add Inventory
              </h3>
              <div className="w-full flex flex-col space-y-8">
                <CustomSelect
                  label="Category"
                  placeholder="Select Category"
                  value={category || ""}
                  onChange={handleCategoryChange}
                  options={categoryList}
                  optionLabelKey="name"
                  optionValueKey="id"
                  required={false} // not mandatory now
                  inline
                  showReset // ✅ enables Reset button
                />

                <LabledInput
                  type="date"
                  label={"Date"}
                  onChange={(e) => setDate(e.target.value)}
                  value={date}
                  placeholder={"Select Date"}
                />

                <LabledInput
                  type="number"
                  label={"Quantity"}
                  onChange={(e) => setCount(e.target.value)}
                  value={count}
                  placeholder={"Enter Quantity"}
                />

                <div className="flex items-center justify-center">
                  <button
                    className="bg-[#FBB034] text-[#202125] py-2 px-6 rounded-md font-poppins text-sm font-bold"
                    onClick={handleSubmit}
                  >
                    Add Inventory
                  </button>
                </div>
              </div>
            </div>
          )}
        </Layout>
      </div>
    </>
  );
};

export default AddInventory;
